import act from '../main/action-const'

const INITIAL_STATE = {
    lista: []
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case act.PEDIDO_LISTADO:
            return {
                ...state, lista: action.payload,
            }

        case act.PEDIDO_CLEAR:
            return {
                INITIAL_STATE,
            }


        default:
            return state
    }
}
